<template>
  <div class="button-container">
    <button :style="styleObject" class="cancel" v-on:click="saveChanges">{{buttonTextC}}</button>
  </div>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    saveChanges() {
      this.$emit('cancel');
    },
  },
  mounted() {

  },
  computed: {
    styleObject() {
      const { cssConfig } = this.$store.getters;
      return {
        '--button-color': 'white',
        '--button-background-color': cssConfig.cancelButton,
        '--button-border-color': cssConfig.cancelButton,
      };
    },
    buttonTextC() {
      if (this.buttonText) {
        return this.buttonText;
      }
      return this.$t('buttons.cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
  button {
    border: none;
    background: none;
    cursor: pointer;
      color: var(--button-border-color);
    font-size: rem(18px);
    font-weight: bold;

    &.cancel, &.save {

      color: white;
      font-size: rem(18px);
      font-weight: bold;
      padding: 12px 50px;
      border-radius: 30px;
      transition: 300ms all ease-in;

    }


    &.cancel {
      background: var(--button-background-color);
      border: 1px solid var(--button-border-color);

      &:hover {
        color: var(--button-border-color);
          background: white !important;
      }
    }
  }
</style>
